import { render, staticRenderFns } from "./PemakaianKlaimPd.vue?vue&type=template&id=66501642&"
import script from "./PemakaianKlaimPd.vue?vue&type=script&lang=js&"
export * from "./PemakaianKlaimPd.vue?vue&type=script&lang=js&"
import style0 from "./PemakaianKlaimPd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports